<script lang="ts" module>
  import Layout from "$app/Layouts/Plan.svelte"
  export const layout = Layout
</script>

<script lang="ts">
  import { onMount } from "svelte"
  import YourProfile from "./Edit/YourProfile.svelte"
  import Notifications from "./Edit/Notifications.svelte"
  import ChangePassword from "./Edit/ChangePassword.svelte"
  import DeleteAccount from "./Edit/DeleteAccount.svelte"
  import { appStore } from "$app/store.svelte"

  interface Props {
    user: UserType
    plans: PlanType[]
    avatar_url: string
  }

  let { user, plans, avatar_url }: Props = $props()

  appStore.current_user = user
  appStore.plans = plans

  type tabType = { title: string; active: boolean; component: any }
  let tabs = $state([
    {
      id: "your-profile",
      title: "Your Profile",
      active: true,
      component: YourProfile
    },
    {
      id: "notifications",
      title: "Emails / Notifications",
      active: false,
      component: Notifications
    },
    {
      id: "password",
      title: "Password",
      active: false,
      component: ChangePassword
    },
    {
      id: "account",
      title: "Delete Account",
      active: false,
      component: DeleteAccount
    }
  ])

  let activeTabTitle = $derived(tabs.find((t) => t.active === true)?.title)

  function updateTab(tab: tabType): void {
    const activeTab = tabs.find((t) => t.active === true)
    activeTab.active = false
    tab.active = true
    tabs = tabs
  }

  onMount(() => {
    var hash = window.location.hash.slice(0, 1)
    if (hash) {
      const tab = tabs.find((t) => t.title.replace(/\s+/g, "") === hash)
      if (tab) {
        updateTab(tab)
      }
    }
  })

  function updateUser(event) {
    user = event.detail
  }
</script>

<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-8">
  <!-- We've used 3xl here, but feel free to try other max-widths based on your needs -->
  <div class="max-w-3xl mx-auto">
    <div class="w-full py-6">
      <p class="text-3xl text-center">Account Settings</p>
    </div>

    <div class="overflow-hidden">
      <div class="sm:hidden">
        <label for="tabs" class="sr-only">Select a tab</label>
        <select
          id="tabs"
          name="tabs"
          class="block w-full focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
          bind:value={activeTabTitle}
          onchange={() => {
            updateTab(tabs.find((t) => t.title === activeTabTitle))
          }}
        >
          {#each tabs as tab (tab.title)}
            <option>{tab.title}</option>
          {/each}
        </select>
      </div>
      <div class="bg-white hidden sm:block">
        <div class="border-b border-gray-200">
          <nav class="tabs -mb-px flex" aria-label="Tabs">
            {#each tabs as tab (tab.title)}
              <a
                href="#{tab.title.replace(/\s/g, '')}"
                class="tab w-1/3"
                class:active={tab.active}
                onclick={() => updateTab(tab)}
              >
                {tab.title}
              </a>
            {/each}
          </nav>
        </div>
      </div>

      <div class="bg-white px-4 py-5 sm:p-6 mt-6 md:mt-0">
        {#each tabs as tab}
          {@const Component = tab.component}
          <div
            data-tabs-target="panel"
            class="px-4 py-5 sm:p-6 bg-white"
            class:hidden={!tab.active}
          >
            <Component on:updateUser={updateUser} />
          </div>
        {/each}
      </div>
    </div>
  </div>
</div>
